import { ReactNode } from 'react';

interface TableRowProps {
  cyTag: string;
  children: ReactNode;
  className?: string;
}

export const TableRow = (props: TableRowProps) => {
  return (
    <td
      data-cy={props.cyTag}
      className={`py-3 pr-3 body-text text-grey-100 ${props.className || ''}`}
    >
      {props.children}
    </td>
  );
};
